import { useMutation, useQueryClient } from "@tanstack/react-query";

//** Request/Response mappings */
import { createQuoteRequestMapping } from "../../mapping/createQuoteRequestMapping.js";
import { createQuoteResponseMapping } from "../../mapping/createQuoteResponseMapping.js";
import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

import { queryKeys } from "./queryKeys.js";

//----------------------------------------------------------------
const putUpdateQuote = async (requestData, isDevShared = false) => {
  if (requestData == null) {
    return;
  }

  //* TODO: Set this back to false.
  //* TODO: isDev PRE-DEPLOY
  const isDev = isDevShared;

  try {
    let mappedRequest = await createQuoteRequestMapping(requestData);
    const accessToken = requestData?.jwtToken;
    const response = await request({
      url: "/updateQuote",
      method: "PUT",
      data: JSON.stringify(mappedRequest),
      accessToken: accessToken,
    });

    if (isDev === true || 200 === response.status) {
      return createQuoteResponseMapping(response);
    } else {
      throw response;
    }
  } catch (error) {
    throw error;
  }
};

export const useUpdateQuoteMutation = () => {
  const queryClient = useQueryClient();
  const { openErrorModal, isDevShared } = useSharedData();

  return useMutation({
    mutationFn: (data) => {
      return putUpdateQuote(data, isDevShared);
    },
    onSuccess: (data) => {
      //* Save the response to the TanStack cache.
      if (data != null) {
        queryClient.setQueryData([queryKeys.QUOTE_DATA_GET], data || {});
        queryClient.invalidateQueries(["premiumProjectionData"]);
      } else {
        openErrorModal();
      }
    },
    onError: (err) => {
      // Do something when an error is thrown
      openErrorModal();
      console.log("Error", err);
    },
  });
};
